/**
 * @deprecated Use useAssets instead. This is provided for backwards compatibility.
 */
export { useAssets as useWriteups } from "./use-assets";
